import { Message } from "../models/Message";
import { Service } from "../models/Service";
import { UserRole } from "../models/User";
import { Channel, ChannelStatus, normalizeChannelConnection } from "../models/Channel";

export const canSeeDeletedContent = ( role?: UserRole | null ): boolean => (
  role === UserRole.ADMIN
);

const presentContent = ( message: Message, role?: UserRole | null ): string => {
  const content = message.content ?? "";

  if( message.channelDeletedAt ) return content;

  return content;
};

export const normalizeMessage = (message: Message, role?: UserRole | null): Message => {
  const replyToMessage = message.replyToMessage
    ? {
      ...message.replyToMessage,
      content: presentContent( message.replyToMessage, role ),
      isForwarded: Boolean( message.replyToMessage.isForwarded ),
      reactions: message.replyToMessage.reactions?.map(( reaction ) => ({
        ...reaction,
        createdAt: reaction.createdAt ? new Date( reaction.createdAt ) : reaction.createdAt,
      })),
      replyToMessage: null,
    }
    : message.replyToMessage;

  return {
    ...message,
    content: presentContent( message, role ),
    isForwarded: Boolean( message.isForwarded ),
    replyToMessage,
    reactions: message.reactions?.map(( reaction ) => ({
      ...reaction,
      createdAt: reaction.createdAt ? new Date( reaction.createdAt ) : reaction.createdAt,
    })),
  };
};

const emptyChannel = ( service: Service ): Channel => ({
  id: service.chat?.channelId ?? "",
  status: ChannelStatus.DISCONNECTED,
  updatedAt: new Date(),
});

export const normalizeService = (service: Service, role?: UserRole | null): Service => {
  const channelSource = service.chat?.channel;
  const channel = channelSource ? normalizeChannelConnection(channelSource) : emptyChannel( service );

  return {
    ...service,
    chat: {
      ...service.chat,
      channelId: service.chat?.channelId || channel.id || undefined,
      channel,
      messages: service.chat?.messages?.map(( message ) => normalizeMessage( message, role )) ?? [],
    },
  };
};
